import React from 'react'
import Hero from './components/cultural-gallery/Hero';
import Main from './components/cultural-gallery/Main';

const CulturalGallery = () => {
  return (
    <div>
        <Hero/>
        <Main/>
    </div>
  )
}

export default CulturalGallery;